import React from 'react'
// hocs
import withObjective from 'components/Modals/PlanItems/Objective/withObjective'
// hooks
import { usePlanAccess } from 'hooks/index'
// components
import { Tab } from '@mui/material'
import { Tabs } from 'components/UI'
import { LoaderWithOverlay } from 'components/UI/Loader'
// context
import { ObjectiveContext } from 'context/index'
// constants
import { ENTITIES } from 'constants/index'
// view components
import CompleteAction from 'components/Modals/PlanItems/Action/MinimizedModal/components/DetailsSection/components/CompleteAction'
import CompleteReview from 'components/Modals/PlanItems/components/CompleteReview'
import DetailsSection from 'components/Modals/PlanItems/Objective/MinimizedModal/components/DetailsSection/index'
import ObjectiveActivitiesList from 'components/Modals/PlanItems/Objective/MinimizedModal/components/ActivitiesList'
import ObjectivesListContainer from 'containers/ObjectivesList'
import ObjectiveResourcesList from 'components/Modals/PlanItems/Objective/MinimizedModal/components/ResourcesList'
import ObjectiveReviewsList from 'components/Modals/PlanItems/Objective/MinimizedModal/components/ReviewsList'
import AuthorizationWarning from 'components/UI/Warnings/AuthorizationWarning'
// views
import { DetailsTab, FlexScrollbar, SubHeader } from 'components/Modals/PlanItems/styles'
import { ActivitiesWrapper } from 'components/Modals/CreateReviewModal/views'
// types
import { LogEntityTypes } from 'types/graphql'

const ObjectiveDetails: React.FC = () => {
  const [tab, setTab] = React.useState(0)

  const { entity, isLoading, plan, update } = React.useContext(ObjectiveContext) as any

  const shouldShowPlan = usePlanAccess(plan)

  const handleSetTab = (_, value) => setTab(value)

  return (
    <>
      <LoaderWithOverlay isLoading={isLoading} />
      {!isLoading && entity && (
        <>
          <SubHeader>
            <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
              <Tab label='Details' />
              <Tab label='Plan' />
              <Tab label='Activity' />
              <Tab label='Resources' />
              <Tab label='Reviews' />
            </Tabs>
          </SubHeader>
          {tab === 0 && (
            <DetailsTab>
              <CompleteAction isObjective entity={entity} update={update} />
              <CompleteReview entity={{ ...entity, entityType: ENTITIES.PLAN_OBJECTIVE }} />
              <FlexScrollbar>
                <DetailsSection entity={{ ...entity, entityType: LogEntityTypes.Objective }} />
              </FlexScrollbar>
            </DetailsTab>
          )}

          {tab === 2 && (
            <ActivitiesWrapper>
              <ObjectiveActivitiesList />
            </ActivitiesWrapper>
          )}

          <div style={{ height: 'calc(100% - 50px)' }}>
            {tab === 1 && (shouldShowPlan ? <ObjectivesListContainer plan={plan} /> : <AuthorizationWarning />)}
            {tab === 3 && <ObjectiveResourcesList />}
            {tab === 4 && <ObjectiveReviewsList />}
          </div>
        </>
      )}
    </>
  )
}

export default withObjective(ObjectiveDetails)
